import React, { useContext } from "react";
import { theme } from "../theme";
import Current from "../components/Current";
import Criteria from "../components/Criteria";
import { General } from "../tools/styles";
import Generic from "../components/Generic";
import RenderIf from "../components/RenderIf"
import {WatchContext} from '../WatchContext'
import handleInputChange from "../tools/handleInputChange";
import calcSedConcern from "../tools/calcSedConcern";
import calcSedComplete from "../tools/calcSedComplete";

const HorSed = () => {
  
  const {horsed, setHorsed} = useContext(WatchContext);
  
  const handleChange = ({ target }) => {
    
    let data = handleInputChange(horsed, target)

    let concernedData = calcSedConcern(data)
  
    let completeData = calcSedComplete(concernedData)
  
    setHorsed(completeData)
  };
  
  return (
    <>
      <General.Heading color={theme.colors.pdeBlue}>
        {horsed.title}
      </General.Heading>
      
      <Generic
     text={horsed.metric}
     title='Metric'
     />
      <Generic
     text={horsed.method}
     title='Method'
     />
      <Current
        currentValue={horsed.currentValue}
        // valDesc="Positive (+) values denote waterward movement of edge
        //     Negative (-) values denote landward movement of edge."
        units={horsed.units}
        just={horsed.currentJust}
        handleChange={handleChange}
        
      />
      <Criteria
        low={horsed.criteriaLow}
        high={horsed.criteriaHigh}
        units={horsed.units}
        type={horsed.criteriaType}
        just={horsed.criteriaJust}
        handleChange={handleChange}
      />
     <Generic
     align='center'
     title='Concerns'
     text={ <>
      <General.InputCont>
      <RenderIf isTrue={horsed.currentConcern === 1}>
      <General.BoldPara>
          {horsed.metric} currently falls outside the healthy range of values.
        </General.BoldPara>
    </RenderIf>
    <RenderIf isTrue={horsed.currentConcern === 0}>
      
        <p>
          {horsed.metric} currently falls within the healthy range of values.
        </p>
      
    </RenderIf>
    <RenderIf isTrue={horsed.currentConcern === -1}>
      
        <p>
          Need more information.
        </p>
      
    </RenderIf>
      </General.InputCont>
    
    
    </>}
     />
      
    </>
  );
};

export default HorSed;
